import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { connect } from "react-redux";
import axios from "axios";
import api from "../dependencies/utils/Api";
import {
  cohortSessionNotesGiveFeedBack,
  detailsGroupSession,
  statusGroupSession,
  cohortSessionGiveFeedBack,
} from "../../AdminModule/Dashboard/MentorDashboard/dependencies/action";
import { withRouter, Link } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import BasicModal from "../summaryMentorModal/Modal";
import swal from "sweetalert";
import "./styles.scss";
import FileUpload from "../FileUpload";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";
import SessionGroupFeedbackModal from "../groupSessionNotesModal";
import StartupFeedBackModal from "../startupFeedBackModal";
import {
  COHORT_NAME_LIST,
  GROUP_SESSION_NAME_LIST,
  MATCH_MENTOR_LIST,
  MATCH_STARTUP_LIST,
} from "../constants/ApplicationUrl";
import CalendarCreateSession from "../calendarCreateSession";
import { IconButton } from "@material-ui/core";
import ModalVisible from "../../AdminModule/Dashboard/MentorDashboard/CohortGroupSession/Modal/modal";
import SessionsMomMentorModal from "../sessionsMomMentorModal";
import { deleteSessionData } from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";
import ModeratorCopy from "../../../assets/svg/dashboard/profile-iconRound.svg";
function SessionsModal2(props) {
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [scheduleModalOpen2, setScheduleModalOpen2] = useState(false);
  const [allMentorList, setAllMentorList] = useState();
  const [allStartupList, setAllStartupList] = useState();
  const [taggingList, setTaggingList] = useState([]);
  const loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const [showEditSession, setShowEditSession] = useState(false);
  const [showEditCohort, setShowEditCohort] = useState(false);
  const [hideModal, setHideModal] = useState(false);
  const [showVideo, setShowVideo] = useState();
  const [sessionMomChildData, setSessionMomChildData] = useState(false);
  const [videoUrl, setVideoUrl] = useState();
  const cohortspeakerarray = [];
  const [videoArr, setVideoArr] = useState([]);
  const [canDelete, setCanDelete] = useState(false);
  props?.groupsessiondata?.speakerUserList?.map((item) => {
    cohortspeakerarray.push(item.name);
  });
  const [linkToggleTextModerator, setLinkToogleTextModerator] = useState(
    "Click to Copy MAAARG session Link as a Moderator"
  );
  const [linkToggleText, setLinkToogleText] = useState(
    "Click to Copy MAAARG session Link"
  );
  const [linkToggleCopy, setLinkToogleCopy] = useState(false);
  const [linkToggleCopyModerator, setLinkToogleCopyModerator] = useState(false);
  const handleView = (videourl, videoArray, cohortAdminId) => {
    setVideoUrl(videourl);
    setShowVideo(true);
    if (
      videoArray !== undefined &&
      videoArray !== null &&
      videoArray !== "" &&
      videoArray?.length > 0
    )
      setVideoArr(videoArray);
    if (cohortAdminId == loggedIn?.id || loggedIn?.role == "Admin") {
      setCanDelete(true);
    } else {
      setCanDelete(false);
    }
  };

  const {
    reloadCalendar,
    reloadCalendarData,
    setModalVisibility,
    modalVisibility,
    cohortSessionNotesGiveFeedBack,
    statusGroupSession,
    detailsGroupSession,
    cohortSessionGiveFeedBack,
  } = props;

  useEffect(() => {
    // axios({
    //   // url: GET_NAMES_DATA,
    //   url: GROUP_SESSION_NAME_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     listKey: "Mentor",
    //   },
    // })
    api
      .POST(MATCH_MENTOR_LIST, {
        cohortId: props?.sessiondata?.sessionData?.cohortId,
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        listKey: "Mentor",
      })
      .then((res) => {
        setAllMentorList(res.data?.data);
      })
      .catch((err) => {});

    // axios({
    //   url: GROUP_SESSION_NAME_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     listKey: "Startup",
    //   },
    // })
    api
      .POST(MATCH_STARTUP_LIST, {
        cohortId: props?.sessiondata?.sessionData?.cohortId,
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        listKey: "Startup",
      })
      .then((res) => {
        setAllStartupList(res.data?.data);
      })
      .catch((err) => {});
  }, []);

  const onBroadcastSelectionChange = (item, checked) => {
    const isThere = taggingList.find((ele) => {
      if (ele == item.id) return true;
    });
    if (checked) {
      if (!isThere) {
        setTaggingList([...taggingList, item.id]);
      }
    } else {
      if (isThere) {
        let newArray = taggingList.filter((ele) => ele != item.id);
        setTaggingList(newArray);
      }
    }
  };
  useEffect(() => {
    var now = new Date();
  }, []);

  const { deleteSessionData } = props;
  const handleClose = () => {
    setModalVisibility(false);
  };
  const handleEdit = () => {
    setScheduleModalOpen(true);
  };
  const handleEdit2 = () => {
    setScheduleModalOpen2(true);
  };
  useEffect(() => {
    // test data for edit button
    //  props?.sessiondata?.sessionData?.sessionType === "cohortSession"

    let testDate =
      props?.sessiondata?.sessionData?.sessionType === "cohortSession" ||
      props?.allCalendarData
        ? props?.groupsessiondata?.sessionStartDate
        : props?.sessiondata?.sessionData?.sessionStart;
    let presentDate3 = moment().format("YYYY-MM-DD");
    let testerDate = moment(testDate).format("DD-MM-YYYY HH:mm A");
    let testerYear = moment(testDate).format("YYYY");
    let testerMonth = moment(testDate).format("MM");
    let testerTime = moment(testDate).subtract(5, "minutes").format("h:mma");
    let beforetime1 = moment(testDate)
      .subtract(60, "minutes")
      .format("DD-MM-YYYY HH:mm A");
    // let beforetime1 = moment(testDate)
    //   .subtract(60, "minutes")
    //   .format("DD-MM-YYYY HH:mm A");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");

    // let testTime = props?.sessiondata?.sessionData?.sessionType === "cohortSession" ? props?.sessiondata?.sessionData?.sessionStart : props?.groupsessiondata?.sessionDate;
    let testToggleType =
      props?.sessiondata?.sessionData?.sessionStart === "cohortSession"
        ? true
        : false; // true = cohort , false = normal session
    // if (
    //   moment().format("DD-MM-YYYY hh:mm A") <
    //   moment(testDate).format("DD-MM-YYYY hh:mm A")
    // ) {
    //   // if(testToggleType)

    //   setShowEditCohort(true);
    //   // else
    //   setShowEditSession(true);
    // } else {
    let sessionDate = moment(testDate).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");
    let sessionTime = moment(testDate).format("h:mma");
    let presentTime2 = moment().format("h:mma");
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let testMonth = moment(testerDate).format("MM");

    // let presentTime2 = moment(presentDate).format("h:mma");
    if (testerYear > currentYear) {
      setShowEditCohort(true);
      setShowEditSession(true);
    } else if (testerYear == currentYear && testerMonth > currentMonth) {
      setShowEditCohort(true);
      setShowEditSession(true);
    } else if (testerYear == currentYear && testerMonth < currentMonth) {
      setShowEditCohort(false);
      setShowEditSession(false);
    } else if (
      (moment(sessionDate).isSame(presentDate) || sessionDate == presentDate) &&
      beforetime1 > presentTime
    ) {
      setShowEditCohort(true);
      setShowEditSession(true);
    } else if (sessionDate > moment().format("DD-MM-YYYY hh:mm A")) {
      setShowEditCohort(true);
      setShowEditSession(true);
    } else {
      // if(testToggleType)
      setShowEditCohort(false);
      // else
      setShowEditSession(false);
    }
    // else {
    //   // if(testToggleType)
    //   setShowEditCohort(false);
    //   // else
    //   setShowEditSession(false);
    // }
    // if(beforetime1 < moment(new Date()).format("DD-MM-YYYY HH:mm A") )
    //   {
    //     setShowEditCohort(true);
    //     setShowEditSession(true);
    //   }
  }, [props?.groupsessiondata]);

  const handleDelete = () => {
    swal("Are you sure you want to delete your Session?", {
      icon: "warning",
      buttons: {
        delete: {
          text: "OK",
        },
        decline: {
          text: "CANCEL",
        },
      },
    }).then((value) => {
      switch (value) {
        case "delete":
          let params = {
            scheduleId: props?.modalData?.scheduleId,
          };
          deleteSessionData(params);
          props?.parentData(true);
          setTimeout(() => {
            swal("Your Session has been deleted!", {
              icon: "success",
            });
            setModalVisibility(false);
          }, 500);
          break;

        case "decline":
          break;
        default:
          swal("Delete operation cancelled");
      }
    });
    // swal({
    //   title: "Are you sure you want to delete your Session?",
    //   // text: "Once deleted, you will not be able to recover this imaginary file!",
    //   icon: "warning",
    //   buttons: true,
    //   confirmButtonColor: 'LightSeaGreen',
    //   cancelButtonColor: 'LightSeaGreen',

    //   // dangerMode: true,
    // })
    // .then((willDelete) => {
    //   if (willDelete) {
    //     let params={
    //       scheduleId:props?.modalData?.scheduleId
    //     }
    //     deleteSessionData(params);
    //     props?.parentData(true);
    //     setTimeout(()=>{
    //       swal("Your Session has been deleted!", {
    //         icon: "success",
    //       });
    //       props?.setModalVisibility(false);
    //     },500)
    //   } else {
    //   }
    // });
  };
  useEffect(() => {
    if (hideModal) {
      setTimeout(() => {
        setModalVisibility(false);
      }, 500);
      setHideModal(false);
    }
  }, [hideModal]);
  const handleMomPopup = (data, totalData) => {
    if (
      data?.sessionType !== undefined &&
      data?.sessionType !== null &&
      data?.sessionType !== "" &&
      data?.sessionType == "cohortSession"
    ) {
      setSessionMomModalCohortOpen(true);
      setSummarySessionData(totalData?.groupsessiondata);
      setCohortGroupSessionId(data?.scheduleId);
      getSessionDetails(data?.scheduleId);
    } else {
      setMentorshipSessionId(data?.mentorshipId);
      setSummarySessionData(data);
      setSessionMomModalOpen(true);
    }

    // setSummarySessionId(sessionList[sessionList?.length-1].scheduleId);
    // setSummarySessionData(sessionList[sessionList?.length-1]);
  };
  const [sessionMomModalOpen, setSessionMomModalOpen] = useState(false);
  const [sessionMomModalCohortOpen, setSessionMomModalCohortOpen] =
    useState(false);
  const [mentorFeedbackModalOpen, setMentorFeedbackModalOpen] = useState(false);
  const [cohortGroupSessionId, setCohortGroupSessionId] = useState("");
  const [mentorshipSessionId, setMentorshipSessionId] = useState();
  const [summarySessionData, setSummarySessionData] = useState();
  const [recordingModalOpen, setRecordingModalOpen] = useState(false);
  let sessionEndTime = moment(
    props?.sessiondata?.sessionData?.sessionEnd
  ).format("YYYY-MM-DD HH:mm A");
  let sessionEndVar = moment(sessionEndTime)
    .add(60, "minutes")
    .format("YYYY-MM-DD HH:mm A");
  let presentTime = moment().format("YYYY-MM-DD HH:mm A");
  const recordingData = [
    {
      id: 1,
      url: props?.sessiondata?.sessionData?.recording,
    },
    {
      id: 2,
      url: props?.sessiondata?.sessionData?.recording,
    },
    {
      id: 3,
      url: props?.sessiondata?.sessionData?.recording,
    },
    {
      id: 4,
      url: props?.sessiondata?.sessionData?.recording,
    },
  ];
  const getSessionDetails = (id) => {
    let params = {
      cohortGroupSessionId: id,
      userId: loggedIn?.id,
    };
    detailsGroupSession(params);
  };
  const newfunctionTime = (
    item,
    currentDateTime,
    sessionStartDate,
    beforetime,
    aftertime,
    sessionStatus
  ) => {
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");
    let ternaryValue =
      item?.sessionStartDate !== undefined &&
      item?.sessionStartDate !== null &&
      item?.sessionStartDate !== ""
        ? item?.sessionStartDate
        : item?.sessionStart;
    let sessionYear = moment(ternaryValue).format("YYYY");
    let sessionMonth = moment(ternaryValue).format("MM");
    let sessionTime = moment(ternaryValue);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionStartTime1 = moment(sessionTime);
    let sessionDate = moment(ternaryValue).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");
    let beforetime1 = moment(sessionStartTime1, "DD-MM-YYYY HH:mm A")
      .subtract(60, "minutes")
      .format("DD-MM-YYYY HH:mm A");
    let endTime = moment(sessionTime)
      .add(sessionDuration + 1, "hours")
      .format("DD-MM-YYYY HH:mm A");

    if (
      sessionYear > currentYear ||
      (sessionYear == currentYear && sessionMonth > currentMonth)
    ) {
      swal({
        title: "Meeting Not Started",
        text: `Cannot join meeting before scheduled time.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    } else if (currentMonth == sessionMonth) {
      if (presentDate > sessionDate) {
        swal({
          title: "Meeting Completed",
          text: `Cannot join a completed meeting.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      } else if (sessionDate === presentDate) {
        if (presentTime >= beforetime1 && endTime >= presentTime) {
          if (loggedIn?.id == props?.groupsessiondata?.cohortAdminId)
            window.open(
              props?.groupsessiondata.vcUrl +
                "?jwt=" +
                props?.groupsessiondata?.jwtToken,
              "_blank"
            );
          else window.open(props?.groupsessiondata.vcUrl);
        } else if (presentTime < beforetime1) {
          swal({
            title: "Meeting Not Started",
            text: `Cannot join meeting before scheduled time.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        } else {
          swal({
            title: "Scheduled Time Over",
            text: `You cannot join meeting.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        }
      } else {
        swal({
          title: "Meeting Not Started",
          text: `Cannot join meeting before scheduled time.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      }
    } else if (sessionYear < currentYear) {
      swal({
        title: "Scheduled Time Over",
        text: `You cannot join meeting.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    }
  };
  const testIncompleteStatus = (item) => {
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");
    let ternaryValue =
      item?.sessionStartDate !== undefined &&
      item?.sessionStartDate !== null &&
      item?.sessionStartDate !== ""
        ? item?.sessionStartDate
        : item?.sessionStart;
    let sessionYear = moment(ternaryValue).format("YYYY");
    let sessionMonth = moment(ternaryValue).format("MM");
    let sessionTime = moment(ternaryValue);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionStartTime1 = moment(sessionTime);
    let sessionDate = moment(ternaryValue).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");
    let beforetime1 = moment(sessionStartTime1, "DD-MM-YYYY HH:mm A").subtract(
      30,
      "minutes"
    );
    let endTime = moment(sessionTime)
      .add(sessionDuration + 1, "hours")
      .format("DD-MM-YYYY HH:mm A");

    if (
      sessionYear > currentYear ||
      (sessionYear == currentYear && sessionMonth > currentMonth)
    ) {
      return false;
    } else if (currentMonth == sessionMonth) {
      if (presentDate > sessionDate) {
        return true;
      } else if (sessionDate === presentDate) {
        if (endTime < presentTime) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else if (sessionYear == currentYear && sessionMonth < currentMonth) {
      return true;
    }
  };
  const testFillNoteVisibility = (props) => {
    if (loggedIn?.role === "Admin") {
      return true;
    }
    if (props?.sessiondata?.sessionData?.sessionType == "mentorSession") {
      if (loggedIn?.role === "Startup")
        return props?.sessiondata?.sessionData?.momStartupSubmitted;
      else if (loggedIn?.role === "Mentor")
        return props?.sessiondata?.sessionData?.momMentorSubmitted;
    } else {
      return props?.groupsessiondata?.isNotesSubmitted;
    }
  };
  useEffect(() => {
    if (sessionMomChildData) {
      setModalVisibility(false);
      setTimeout(() => {
        setSessionMomChildData(false);
      }, 2000);
    }
  }, [sessionMomChildData]);
  const testClipVisibility = (item) => {
    let testYear = moment(item?.sessionStartDate).format("YYYY");
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let testMonth = moment(item?.sessionStartDate).format("MM");
    if (testYear > currentYear) return false;
    else if (testYear == currentYear && testMonth > currentMonth) return false;
    else
      return (
        moment().format("DD-MM-YYYY HH:mm A") >
          moment(
            moment(
              moment(item?.sessionStartDate).format("DD-MM-YYYY HH:mm A"),
              "DD-MM-YYYY HH:mm A"
            )
              .add(item?.sessionDuration, "hours")
              .format("DD-MM-YYYY HH:mm A"),
            "DD-MM-YYYY HH:mm A"
          )
            .add(60, "minutes")
            .format("DD-MM-YYYY HH:mm A") && item?.sessionStatus === "SCHEDULED"
      );
  };
  useEffect(() => {
    if (linkToggleCopy) {
      setTimeout(() => {
        setLinkToogleCopy(false);
        setLinkToogleText("Click to join MAAARG session Link");
      }, 5000);
    }
  }, [linkToggleCopy]);
  useEffect(() => {
    if (linkToggleCopyModerator) {
      setTimeout(() => {
        setLinkToogleCopyModerator(false);
        setLinkToogleTextModerator(
          "Click to join MAAARG session Link as a Moderator"
        );
      }, 5000);
    }
  }, [linkToggleCopyModerator]);
  return (
    <>
      <div className="modal-dialog modal-dialog-centered">
        <Modal
          size="lg"
          show={modalVisibility}
          onHide={() => setModalVisibility(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
          className={
            props?.type === "sessiondetail"
              ? "sessiondetailmodal newmodalmysession"
              : ""
          }
        >
          <SessionsMomMentorModal
            modalVisibility={sessionMomModalOpen}
            setModalVisibility={setSessionMomModalOpen}
            // modalData={sessionModalData}
            mentorshipId={mentorshipSessionId}
            sessionData={summarySessionData}
            parentData={setSessionMomChildData}
          />
          {sessionMomModalCohortOpen && sessionMomModalCohortOpen === true && (
            <SessionGroupFeedbackModal
              modalVisibility={sessionMomModalCohortOpen}
              setModalVisibility={setSessionMomModalCohortOpen}
              postFeedBack={cohortSessionNotesGiveFeedBack}
              viewMode={false} //true if view feedback, false if post feedback
              modalData={summarySessionData}
              parentData={setSessionMomChildData}
              updateStatus={statusGroupSession}
              fromPage={"groupPage"}
              cohortGroupId={cohortGroupSessionId}
            />
          )}
          {mentorFeedbackModalOpen && mentorFeedbackModalOpen === true && (
            <StartupFeedBackModal
              modalVisibility={mentorFeedbackModalOpen}
              setModalVisibility={setMentorFeedbackModalOpen}
              cohortSession={true}
              postFeedBack={cohortSessionGiveFeedBack}
              viewMode={false} //true if view feedback, false if post feedback
              feedBackData={undefined} // if viewMode is true, show the rating
              parentData={setSessionMomChildData}
              cohortGroupId={cohortGroupSessionId}
            />
          )}
          <BasicModal
            videoUrl={videoUrl}
            open={showVideo}
            setOpen={setShowVideo}
            videoList={videoArr}
            canDelete={canDelete}
          />
          <Modal.Header className="d-flex mainmodalheaddiv">
            {scheduleModalOpen === true && (
              <ModalVisible
                modalOpen={scheduleModalOpen}
                allMentorList={allMentorList}
                allStartupList={allStartupList}
                // mentorshipId={params.mentorshipId}
                setModalOpen={setScheduleModalOpen}
                onBroadcastSelectionChange={onBroadcastSelectionChange}
                setTaggingList={setTaggingList}
                taggingList={taggingList}
                editData={props && props?.groupsessiondata}
                parentData={reloadCalendar}
                fromPage="Calendar"
                hideModal={setHideModal}
              />
            )}
            {scheduleModalOpen2 === true && (
              <CalendarCreateSession
                modalOpen={scheduleModalOpen2}
                setModalOpen={setScheduleModalOpen2}
                EditModalValue={true}
                modalData={props?.sessiondata?.sessionData}
                parentData={reloadCalendar}
                hideModal={setHideModal}
              />
            )}
            <Modal.Title
              className="modalHeading mainmodalhead"
              style={{
                width: "100%",
              }}
            >
              {props?.sessiondata?.sessionData?.sessionType ===
                "cohortSession" || props?.allCalendarData
                ? "MAARG Cohort Group Session"
                : "MAARG Meeting Session"}
            </Modal.Title>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
            />
          </Modal.Header>

          {props?.sessiondata?.sessionData?.sessionType != undefined &&
          props?.sessiondata?.sessionData?.sessionType != "cohortSession" ? (
            <Modal.Title
              className="modalHeading "
              style={{
                fontSize: "14px",
                width: "100%",
                paddingLeft: "1.8rem",
                paddingRight: "1.8rem",
                paddingTop: "10px",
                paddingBottom: "10px",
                // borderBottom: "1px solid #dee2e6",
                display: "flex",

                // padding: "10px 2.5rem",
                justifyContent: "space-between",
              }}
            >
              Mentorship ID: M
              {props?.sessiondata?.sessionData?.mentorshipId
                ?.toString()
                .slice(
                  props?.sessiondata?.sessionData?.mentorshipId.length - 6
                )}
              {/* {props?.sessiondata?.sessionData?.sessionStatus != "COMPLETED" &&
              new Date(
                moment(props?.sessiondata?.sessionData?.sessionEnd).format(
                  "YYYY-MM-DDThh:mm:ssZ"
                )
              ) >= new Date() ? (
                <a
                  href={props?.sessiondata?.sessionData?.vcUrl}
                  target="_blank"
                  style={{
                    color: "#563A96",
                    fontWeight: 600,
                    fontSize: "14px",
                    width: "fit-content",
                    textDecoration: "underline",
                  }}
                >
                  Click to Join MAARG Session
                </a>
              ) : (
                ""
              )} */}
            </Modal.Title>
          ) : (
            ""
          )}
          {/* <Modal.Title
            className="modalHeading"
            style={{
              fontSize: "14px",
              width: "100%",
              paddingLeft: "1.8rem",
              paddingRight: "1.8rem",
              paddingTop: "10px",
              paddingBottom: "10px",
              // borderBottom: "1px solid #dee2e6",
              display: "flex",

              // padding: "10px 2.5rem",
              justifyContent: "space-between",
            }}
          >
            Mentorship ID: M
            {props?.sessiondata?.sessionData?.mentorshipId
              ?.toString()
              .slice(props?.sessiondata?.sessionData?.mentorshipId.length - 6)}
           
          </Modal.Title> */}
          {/* {props?.sessiondata?.sessionData?.cohortId != null ? (
            <Modal.Title
              className="modalHeading "
              style={{
                fontSize: "14px",
                width: "100%",
                paddingLeft: "1.8rem",
                paddingRight: "1.8rem",
                paddingTop: "10px",
                paddingBottom: "10px",
                borderBottom: "1px solid #dee2e6",
                display: "flex",
                // padding: "10px 2.5rem",
                justifyContent: "space-between",
                paddingTop: "0px",
                // marginTop: "-15px",
              }}
            >
              Cohort ID: C
              {props?.sessiondata?.sessionData?.cohortId
                ?.toString()
                .slice(props?.sessiondata?.sessionData?.cohortId.length - 6)}
            </Modal.Title>
          ) : (
            ""
          )} */}

          <Modal.Title
            className="modalHeading modalnewhead2"
            style={{
              fontSize: "14px",
              width: "100%",
              // paddingLeft: "1.8rem",
              paddingRight: "1.8rem",
              overflow: "scroll",
              overflowX: "hidden",
              height: "300px",
            }}
          >
            {/* {`Session Scheduled at ${
              props?.sessiondata?.daySpawns
                ? props?.sessiondata?.daySpawns[0]
                : props?.sessiondata?.originDate
            } 
            - ${
              props?.sessiondata?.daySpawns
                ? props?.sessiondata?.daySpawns[1]
                : props?.sessiondata?.originDate
            } 
            `}{" "} */}
            {(props?.sessiondata?.sessionData?.sessionType ===
              "cohortSession" ||
              props?.allCalendarData) && (
              <>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#3E4A59",
                    // lineHeight: "35px",
                  }}
                >
                  Cohort Name:{" "}
                  {`${props?.groupsessiondata?.cohortApplication?.program_name}`}{" "}
                  {props?.groupsessiondata?.cohortApplication?.cohortId !=
                    null &&
                    `(C${props?.groupsessiondata?.cohortApplication?.cohortId
                      ?.toString()
                      .slice(
                        props?.groupsessiondata?.cohortApplication?.cohortId
                          .length - 6
                      )})
                    `}
                </div>
              </>
            )}
            {(props?.sessiondata?.sessionData?.sessionType ===
              "cohortSession" ||
              props?.allCalendarData) && (
              <>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    // paddingBottom: "10px",
                    color: "rgb(62, 74, 89)",
                  }}
                >
                  Session Title: {props?.groupsessiondata?.sessionTitle}
                  <p
                    style={{
                      fontWeight: "normal",
                      fontSize: "14px",
                      lineHeight: "22px",
                      paddingLeft: "2rem",
                      color: "rgb(62, 74, 89)",
                    }}
                  >
                    {/* {props?.groupsessiondata?.desiredOutcomes} */}
                  </p>
                </div>
              </>
            )}
            {props?.sessiondata?.sessionData?.sessionType === "cohortSession" ||
            props?.allCalendarData ? (
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#3E4A59",
                  lineHeight: "25px",
                }}
              >
                {`${props?.sessiondata?.summary2}`}{" "}
                {/* {`(${props?.sessiondata?.sessionData?.sessionStatus})`} */}
                {testIncompleteStatus(props?.sessiondata?.sessionData) &&
                props?.sessiondata?.sessionData?.sessionStatus !==
                  "COMPLETED" &&
                props?.sessiondata?.sessionData?.sessionStatus !== "CANCELLED"
                  ? "(CLOSED)"
                  : props?.sessiondata?.sessionData?.sessionStatus ===
                    "COMPLETED"
                  ? "(COMPLETE)"
                  : // new Date(
                  //   moment(props?.sessiondata?.sessionData?.sessionEnd).format(
                  //     "YYYY-MM-DDThh:mm:ssZ"
                  //   )
                  // ) < new Date()

                  props?.sessiondata?.sessionData?.sessionStatus === "CANCELLED"
                  ? "(CANCELLED)"
                  : props?.sessiondata?.sessionData?.sessionStatus ===
                    "SCHEDULED"
                  ? "(SCHEDULED)"
                  : props?.sessiondata?.sessionData?.sessionStatus ===
                    "AUTOCOMPLETED"
                  ? "(CLOSED )"
                  : ""}
                {/* {props?.sessiondata?.sessionData?.sessionStatus === "COMPLETED"
                  ? "(COMPLETE)"
                  : props?.sessiondata?.sessionData?.sessionStatus ==
                      "SCHEDULED" &&
                      sessionEndVar < presentTime 
                    // new Date(
                    //   moment(props?.sessiondata?.sessionData?.sessionEnd).format(
                    //     "YYYY-MM-DDThh:mm:ssZ"
                    //   )
                    // ) < new Date()
                  ? "(INCOMPLETE)"
                  : props?.sessiondata?.sessionData?.sessionStatus ===
                    "CANCELLED"
                  ? "(CANCELLED)"
                  : "(SCHEDULED)"} */}
              </div>
            ) : (
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#3E4A59",
                  lineHeight: "25px",
                }}
              >
                {`${props?.sessiondata?.summary2}`}{" "}
                {/* {props?.sessiondata?.sessionData?.sessionStatus == "SCHEDULED" &&
                new Date(
                  moment(props?.sessiondata?.sessionData?.sessionEnd).format(
                    "YYYY-MM-DDThh:mm:ssZ"
                  )
                ) < new Date()
                  ? "(INCOMPLETE)"
                  : `(${props.sessiondata?.sessionData?.sessionStatus})`} */}
                {props.sessiondata?.sessionData?.sessionStatus === "COMPLETED"
                  ? "(COMPLETE)"
                  : props.sessiondata?.sessionData?.sessionStatus ===
                    "CANCELLED"
                  ? "(CANCELLED)"
                  : props.sessiondata?.sessionData?.sessionStatus ==
                      "SCHEDULED" &&
                    testIncompleteStatus(props.sessiondata?.sessionData)
                  ? //   &&
                    // new Date(
                    //   moment(props.sessiondata?.sessionData?.sessionEnd).format(
                    //     "YYYY-MM-DDThh:mm:ssZ"
                    //   )
                    // ) < new Date()
                    "(CLOSED)"
                  : "(SCHEDULED)"}
              </div>
            )}
            {(props?.sessiondata?.sessionData?.sessionType ===
              "cohortSession" ||
              props?.allCalendarData) && (
              <>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#3E4A59",
                    lineHeight: "35px",
                  }}
                >
                  Session Speakers: {cohortspeakerarray?.join(", ")}
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#3E4A59",
                    lineHeight: "32px",
                  }}
                >
                  Total Attendees: {props?.groupsessiondata?.totalParticipant}
                  {/* {props?.groupsessiondata?.mentors?.length +
                    props?.groupsessiondata?.speakers?.length +
                    props?.groupsessiondata?.startups?.length} */}
                </div>
              </>
            )}{" "}
            {props?.sessiondata?.sessionData?.sessionType != "cohortSession" &&
              !props?.allCalendarData && (
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#3E4A59",
                    lineHeight: "35px",
                  }}
                >
                  Mentor Name: {props?.sessiondata?.sessionData?.mentor?.name}
                </div>
              )}
            {props?.sessiondata?.sessionData?.sessionType != "cohortSession" &&
              !props?.allCalendarData && (
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#3E4A59",
                    lineHeight: "22px",
                  }}
                >
                  Startup Name: {props?.sessiondata?.sessionData?.startup?.name}
                </div>
              )}
            {/* { props?.sessiondata?.sessionData?.sessionStatus === "COMPLETED"  &&  ( */}
            <div
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                color: "#3E4A59",
                lineHeight: "35px",
              }}
            >
              Session Details:
              <p
                style={{
                  fontWeight: "normal",
                  fontSize: "14px",
                  lineHeight: "22px",
                  paddingLeft: "2rem",
                }}
              >
                {`Date & Time : ${
                  props?.sessiondata?.daySpawns
                    ? props?.sessiondata?.daySpawns[0]
                    : props?.sessiondata?.originDate
                } ${moment(
                  props?.sessiondata?.sessionData?.sessionTime,
                  "hh:mm"
                ).format("hh:mm a")}
                Duration : ${
                  props?.sessiondata?.sessionData?.sessionType ===
                    "cohortSession" || props?.allCalendarData
                    ? props?.groupsessiondata?.sessionDuration + " hours"
                    : props?.sessiondata?.sessionData?.sessionDuration +
                      " hours"
                }
                
            `}

                {props?.sessiondata?.sessionData?.actualDuration &&
                props?.sessiondata?.sessionData?.actualDuration !== undefined &&
                props?.sessiondata?.sessionData?.actualDuration !== "" &&
                props?.sessiondata?.sessionData?.actualDuration !== null &&
                props?.sessiondata?.sessionData?.actualDuration !== 0 &&
                props?.sessiondata?.sessionData?.sessionFormat === "ONLINE" ? (
                  <>
                    {" "}
                    <br /> Actual Duration :{" "}
                    {props?.sessiondata?.sessionData?.actualDuration} hours
                  </>
                ) : (
                  ""
                )}
                 {
                props?.sessiondata?.sessionData?.sessionType ==
                "cohortSession" &&
                props?.groupsessiondata?.sessionFormat == "ONLINE" &&
                !props?.allCalendarData && props?.sessiondata?.sessionData?.actualDuration !== null && props?.sessiondata?.sessionData?.actualDuration !== "" && props?.sessiondata?.sessionData?.actualDuration > 0  ?
                <>
                {" "}
                <br /> Actual Duration :{" "}
                {props?.sessiondata?.sessionData?.actualDuration} hours
              </>:""
                }
               
                {props?.sessiondata?.sessionData?.sessionType ==
                  "cohortSession" &&
                  !props?.allCalendarData ?
                  <>
                  <br/>
                  Session Format : {
                    props?.groupsessiondata?.sessionFormat === "ONLINE"
                      ? "On Maarg Platform"
                      : "Offline"
                  }
                </>
                : !props?.allCalendarData &&
                <>
                <br/>
                Session Format : {
                  props?.sessiondata?.sessionData?.sessionFormat === "ONLINE"
                    ? "On Maarg Platform"
                    : "Offline"
                }
              </>
                }
                {props?.allCalendarData &&
                  props?.sessiondata?.sessionData?.sessionFormat !==
                    undefined &&
                  props?.sessiondata?.sessionData?.sessionFormat !== null && (
                    <>
                      <br />
                      Session Format :{" "}
                      {props?.sessiondata?.sessionData?.sessionFormat ===
                      "ONLINE"
                        ? "On Maarg Platform"
                        : "Offline"}
                    </>
                  )}
              </p>
             
              {
               (( props?.groupsessiondata?.sessionStatus == "SCHEDULED" &&
                props?.groupsessiondata?.sessionFormat == "ONLINE") ||( props?.sessiondata?.sessionData?.sessionStatus == "SCHEDULED" && props?.sessiondata?.sessionData?.sessionFormat == "ONLINE") )&&
                <>
                  
                              <div>
                      <div
                        className="d-flex"
                        style={{ gap:"10px",marginTop:"10px" }}
                      >
                        <div
                                className="newuserTooltip"
                                style={{ marginLeft: "2rem" }}
                              >
                                <a
                                  style={{
                                    color: "#563A96",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  // target="_blank"
                                  href={"javascript:void(0)"}
                                  onClick={() => {
                                    if(props?.sessiondata?.sessionData?.sessionType == "cohortSession")
                                   {
                                    newfunctionTime(
                                      props?.groupsessiondata
                                    );
                                   }
                                    else{
                                      newfunctionTime(
                                        props?.sessiondata?.sessionData
                                      );
                                    }
                                  }}
                                >
                                  Join MAARG Session Link
                                </a>
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "10px",
                                    top: "30px",
                                    width: "240px",
                                    backgroundColor: "rgb(184,153,207)",
                                    padding:"0px"
                                  }}
                                >
                                  Click to join the session
                                </span>
                              </div>
                        <div>
                          <div
                            className="d-flex justify-content-end newuserTooltip"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              // navigator.clipboard.writeText(item.vcUrl);
                              setLinkToogleCopy(true);
                              // setClipBoardData(item)
                              // getSessionDetails(item?.cohortGroupSessionId);
                              //      navigator.clipboard.writeText(
                              //   `Meeting at : ${moment(
                              //     item.sessionDate
                              //   ).format(
                              //     "DD-MM-YYYY"
                              //   )} ${item?.sessionTime}\nDuration (Hours): ${
                              //     item?.sessionDuration
                              //   }\nJoin MAARG Meeting:\n${item?.vcUrl}`
                              // )
                              let item = "";
                              if(props?.sessiondata?.sessionData?.sessionType == "cohortSession")
                            {
                              item=
                               props?.groupsessiondata
                             
                            }
                             else{
                              item=props?.sessiondata?.sessionData
                               
                             }

                              navigator.clipboard.writeText(
                                `You are Invited to a scheduled MAARG meeting:\n\nTopic : MAARG Meeting \nTime : ${moment(
                                  item?.sessionStartDate
                                ).format("MMM. D, YYYY")} ${moment(
                                  item.sessionStartDate
                                ).format("hh:mm a")} (${
                                  moment
                                    .tz(
                                      item?.sessionStartDate,
                                      Intl.DateTimeFormat().resolvedOptions()
                                        .timeZone
                                    )
                                    .format("z")
                                    .includes("-")
                                    ? "GMT" +
                                      moment
                                        .tz(
                                          item?.sessionStartDate,
                                          Intl.DateTimeFormat().resolvedOptions()
                                            .timeZone
                                        )
                                        .format("z")
                                    : moment
                                        .tz(
                                          item?.sessionStartDate,
                                          Intl.DateTimeFormat().resolvedOptions()
                                            .timeZone
                                        )
                                        .format("z")
                                })
                                                  \nDuration (Hours): ${
                                                    item?.sessionDuration
                                                  }\n\nJoin MAARG Meeting:\n${
                                  item?.vcUrl
                                }`
                              );

                              setLinkToogleText(
                                "Your MAARG Session Link is copied"
                              );
                            }}
                          >
                            <span
                              className="tooltiptext tooltip-bottom"
                              style={
                                linkToggleCopy
                                  ? {
                                      left: "-35px",
                                      top: "30px",
                                      width: "240px",
                                      padding:"0",
                                      backgroundColor: "rgb(184,153,207)",
                                    }
                                  : {
                                      left: "-35px",
                                      top: "30px",
                                      width: "240px",
                                      padding:"0",
                                      backgroundColor: "#816ab0",
                                    }
                              }
                            >
                              {linkToggleText}
                            </span>
                            <ContentCopyIcon />
                          </div>
                          <div
                            className="d-flex mt-2"
                            style={{ justifyContent: "space-between" }}
                          >
                            {testClipVisibility(props?.groupsessiondata)
                              ? ""
                              : (loggedIn?.id == props?.groupsessiondata?.cohortAdminId || loggedIn?.role == "Admin" )&& (
                                  <div
                                    className="d-flex justify-content-end newuserTooltip"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      // navigator.clipboard.writeText(item.vcUrl);
                                      setLinkToogleCopyModerator(true);
                                      // setClipBoardData(item)
                                      // getSessionDetails(item?.cohortGroupSessionId);
                                      //      navigator.clipboard.writeText(
                                      //   `Meeting at : ${moment(
                                      //     item.sessionDate
                                      //   ).format(
                                      //     "DD-MM-YYYY"
                                      //   )} ${item?.sessionTime}\nDuration (Hours): ${
                                      //     item?.sessionDuration
                                      //   }\nJoin MAARG Meeting:\n${item?.vcUrl}`
                                      // )
                                      navigator.clipboard.writeText(
                                        `You are Invited to a scheduled MAARG meeting:\n\nTopic : MAARG Meeting \nTime : ${moment(
                                          props?.groupsessiondata?.sessionStartDate
                                        ).format("MMM. D, YYYY")} ${moment(
                                          props?.groupsessiondata.sessionStartDate
                                        ).format("hh:mm a")} (${
                                          moment
                                            .tz(
                                              props?.groupsessiondata?.sessionStartDate,
                                              Intl.DateTimeFormat().resolvedOptions()
                                                .timeZone
                                            )
                                            .format("z")
                                            .includes("-")
                                            ? "GMT" +
                                              moment
                                                .tz(
                                                  props?.groupsessiondata?.sessionStartDate,
                                                  Intl.DateTimeFormat().resolvedOptions()
                                                    .timeZone
                                                )
                                                .format("z")
                                            : moment
                                                .tz(
                                                  props?.groupsessiondata?.sessionStartDate,
                                                  Intl.DateTimeFormat().resolvedOptions()
                                                    .timeZone
                                                )
                                                .format("z")
                                        })
                                                  \nDuration (Hours): ${
                                                    props?.groupsessiondata?.sessionDuration
                                                  }\n\nJoin MAARG Meeting:\n${
                                                    props?.groupsessiondata?.vcUrl + "?jwt=" + props?.groupsessiondata?.jwtToken
                                        }`
                                      );

                                      setLinkToogleTextModerator(
                                        "Your MAARG Session Moderator Link is copied"
                                      );
                                    }}
                                  >
                                    <span
                                      className="tooltiptext tooltip-bottom"
                                      style={
                                        linkToggleCopyModerator
                                          ? {
                                              left: "-10rem",
                                              top: "30px",
                                              width: "350px",
                                              padding:"0",
                                              backgroundColor:
                                                "rgb(184,153,207)",
                                            }
                                          : {
                                              left: "-10rem",
                                              top: "30px",
                                              width: "350px",
                                              padding:"0",
                                              backgroundColor: "#816ab0",
                                            }
                                      }
                                    >
                                      {linkToggleTextModerator}
                                    </span>
                                    <img
                                      src={ModeratorCopy}
                                      height={30}
                                      width={30}
                                      style={{
                                        position: "relative",
                                        left: "10.25%",
                                      }}
                                    />
                                  </div>
                                )}
                          </div>
                        </div>
                      </div>
                    </div>
               
                </>
              }
              {props?.sessiondata?.sessionData?.sessionType !=
                "cohortSession" && (
                <p
                  style={{
                    fontWeight: "normal",
                    fontSize: "14px",
                    lineHeight: "22px",
                    paddingLeft: "2rem",
                  }}
                >
                  {props?.sessiondata?.sessionData?.sessionStatus ===
                    "COMPLETED" ||
                  props?.sessiondata?.sessionData?.sessionStatus ==
                    "CANCELLED" ||
                  props?.sessiondata?.sessionData?.sessionStatus ==
                    "AUTOCOMPLETED" ||
                  props?.sessiondata?.sessionData?.sessionStatus == "CLOSED"
                    ? ""
                    : props?.sessiondata?.sessionData?.sessionStatus ==
                      "SCHEDULED"
                    ? ""
                    : props?.sessiondata?.sessionData?.sessionStatus ===
                      "CANCELLED"
                    ? ""
                    : props?.sessiondata?.sessionData?.sessionStatus ==
                        "SCHEDULED" &&
                      testIncompleteStatus(
                        props?.sessiondata?.sessionData?.sessionStartDate
                      ) && (
                        <>
                          <div className="d-flex">
                            Session Format:{" "}
                            {props?.sessiondata?.sessionData.sessionFormat ===
                            "OFFLINE" ? (
                              "Offline"
                            ) : (
                              <div
                                className="newuserTooltip"
                                style={{ marginLeft: "0.5rem" }}
                              >
                                <a
                                  style={{
                                    color: "#563A96",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  // target="_blank"
                                  href={"javascript:void(0)"}
                                  onClick={() => {
                                    // let sessionStartDate1 = moment(
                                    //   props?.sessiondata?.sessionData?.sessionStartDate
                                    // ).format("DD-MM-YYYY HH:mm A");

                                    let sessionStartDate1 = `${
                                      props?.sessiondata?.daySpawns
                                        ? props?.sessiondata?.daySpawns[0]
                                        : props?.sessiondata?.originDate
                                    } ${moment(
                                      props?.sessiondata?.sessionData
                                        ?.sessionTime,
                                      "hh:mm"
                                    ).format("hh:mm a")}`;
                                    let sessionEndDate1 = moment(
                                      sessionStartDate1,
                                      "DD-MM-YYYY HH:mm A"
                                    )
                                      .add(
                                        props?.sessiondata?.sessionData
                                          ?.sessionDuration,
                                        "hours"
                                      )
                                      .format("DD-MM-YYYY HH:mm A");
                                    let beforetime1 = moment(sessionStartDate1)
                                      .subtract(60, "minutes")
                                      .format("DD-MM-YYYY HH:mm A");
                                    // let beforetime1 = moment(
                                    //   sessionStartDate1,
                                    //   "DD-MM-YYYY HH:mm A"
                                    // )
                                    //   .subtract(5, "minutes")
                                    //   .format("DD-MM-YYYY HH:mm A");
                                    let aftertime1 = moment(
                                      sessionEndDate1,
                                      "DD-MM-YYYY HH:mm A"
                                    )
                                      .add(60, "minutes")
                                      .format("DD-MM-YYYY HH:mm A");
                                    let currentDateTime1 =
                                      moment().format("DD-MM-YYYY HH:mm A");
                                    if (currentDateTime1 < beforetime1) {
                                      swal({
                                        title: "Meeting Not Started",
                                        text: `Cannot join meeting before scheduled time.`,
                                        icon: "error",
                                        // timer: 1500,
                                        // buttons: false,
                                      });
                                    } else if (currentDateTime1 > aftertime1) {
                                      if (
                                        props?.sessiondata?.sessionData
                                          ?.sessionStatus === "SCHEDULED"
                                      ) {
                                        swal({
                                          title: "Scheduled Time Over",
                                          text: `You cannot join meeting.`,
                                          icon: "error",
                                          // timer: 1500,
                                          // buttons: false,
                                        });
                                      } else {
                                        swal({
                                          title: "Meeting Completed",
                                          text: `Cannot join a completed meeting.`,
                                          icon: "error",
                                          // timer: 1500,
                                          // buttons: false,
                                        });
                                      }
                                      // window.open(props?.modalData?.vcUrl, "_blank");
                                    } else {
                                      if (
                                        loggedIn?.id ==
                                        props?.groupsessiondata?.cohortAdminId
                                      )
                                        window.open(
                                          props?.sessiondata?.sessionData
                                            ?.vcUrl +
                                            "?jwt=" +
                                            props?.sessiondata?.sessionData
                                              ?.jwtToken,
                                          "_blank"
                                        );
                                      else
                                        window.open(
                                          props?.sessiondata?.sessionData?.vcUrl
                                        );
                                    }
                                  }}
                                >
                                  Join MAARG Session Link
                                </a>
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "-35px",
                                    top: "30px",
                                    width: "240px",
                                    backgroundColor: "rgb(184,153,207)",
                                  }}
                                >
                                  Click to join the session
                                </span>
                              </div>
                            )}
                          </div>
                        </>
                      )}
                </p>
              )}
              {(props?.sessiondata?.sessionData?.sessionType ===
                "cohortSession" ||
                props?.allCalendarData) && (
                <p
                  style={{
                    fontWeight: "normal",
                    fontSize: "14px",
                    lineHeight: "22px",
                    paddingLeft: "2rem",
                  }}
                >
                  {(props?.sessionData !== undefined &&
                    props?.sessiondata?.sessionData?.sessionStatus ===
                      "COMPLETED") ||
                  props?.sessiondata?.sessionData?.sessionStatus ==
                    "CANCELLED" ||
                  props?.sessiondata?.sessionData?.sessionStatus ==
                    "AUTOCOMPLETED" ||
                  props?.sessiondata?.sessionData?.sessionStatus == "CLOSED"
                    ? ""
                    : props?.sessionData !== undefined &&
                      props?.sessiondata?.sessionData?.sessionStatus ===
                        "CANCELLED"
                    ? ""
                    : // testWeblinkVisibility(props?.sessiondata?.sessionData)
                      props?.sessionData !== undefined &&
                      props?.sessiondata?.sessionData?.sessionStatus !==
                        "COMPLETED" &&
                      props?.sessiondata?.sessionData?.sessionStatus !==
                        "CANCELLED" &&
                      props?.sessiondata?.sessionData?.sessionStatus !==
                        "CLOSED" && (
                        <>
                          <div className="d-flex">
                            Session Format:{" "}
                            {props?.sessiondata?.sessionData.sessionFormat ===
                            "OFFLINE" ? (
                              "Offline"
                            ) : (
                              <div
                                className="newuserTooltip"
                                style={{ marginLeft: "0.5rem" }}
                              >
                                <a
                                  style={{
                                    color: "#563A96",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  // target="_blank"
                                  href={"javascript:void(0)"}
                                  onClick={() => {
                                    newfunctionTime(
                                      props?.sessiondata?.sessionData
                                    );
                                  }}
                                >
                                  Join MAARG Session Link
                                </a>
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "-35px",
                                    top: "30px",
                                    width: "240px",
                                    backgroundColor: "rgb(184,153,207)",
                                  }}
                                >
                                  Click to join the session
                                </span>
                              </div>
                            )}
                          </div>

                          {props?.groupsessiondata?.venue !== null &&
                            props?.groupsessiondata?.venue !== "" && (
                              <div>Venue: {props?.groupsessiondata?.venue}</div>
                            )}
                          {props?.groupsessiondata?.address !== null &&
                            props?.groupsessiondata?.address !== "" && (
                              <div>
                                Address: {props?.groupsessiondata?.address}
                              </div>
                            )}
                          {props?.groupsessiondata?.phoneNo !== null &&
                            props?.groupsessiondata?.phoneNo !== "" && (
                              <div>
                                Contact Number: {"+"}
                                {props?.groupsessiondata?.phoneNo}
                              </div>
                            )}
                          {props?.groupsessiondata?.directions !== null &&
                            props?.groupsessiondata?.directions !== "" && (
                              <div className="d-flex">
                                Direction Link:{" "}
                                <div className="newuserTooltip">
                                  <Link
                                    style={{
                                      color: "#563A96",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                      marginLeft: "0.5rem",
                                    }}
                                    onClick={() =>
                                      window.open(
                                        props?.groupsessiondata?.directions,
                                        "_blank"
                                      )
                                    }
                                  >
                                    {" "}
                                    Click to view directions to the venue.
                                  </Link>
                                  <span className="tooltiptext tooltip-bottom sessionsModalTooltip">
                                    Click to view directions to the venue.
                                  </span>
                                </div>
                              </div>
                            )}
                        </>
                      )}
                  {(props?.sessiondata?.sessionData?.sessionFormat ===
                    "OFFLINE" ||
                    props?.sessiondata?.sessionData?.sessionFormat ===
                      "OTHER") &&
                  (props?.sessiondata?.sessionData?.otherDetail === "" ||
                    props?.sessiondata?.sessionData?.otherDetail === null ||
                    props?.sessiondata?.sessionData?.otherDetail ===
                      undefined ||
                    !props?.sessiondata?.sessionData?.otherDetail) ? (
                    ""
                  ) : (
                    <>
                      {props?.sessiondata?.sessionData?.sessionStatus !=
                        "COMPLETED" &&
                      (props?.sessiondata?.sessionData?.sessionFormat ===
                        "OFFLINE" ||
                        props?.sessiondata?.sessionData?.sessionFormat ===
                          "OTHER")
                        ? "Other Platform:"
                        : ""}{" "}
                      {props?.sessiondata?.sessionData?.otherDetail}
                    </>
                  )}
                </p>
              )}
              {
                props?.sessiondata?.sessionData?.sessionType ==
                "cohortSession" &&
                !props?.allCalendarData && props?.groupsessiondata?.recordings?.length > 0  ?
                <>
                  <div
                  style={{
                    fontWeight: "normal",
                    fontSize: "14px",
                    lineHeight: "22px",
                    paddingLeft: "2rem",
                    display: "flex",
                  }}
                >
                  Recording Playback:{" "}
                      <p
                        className="newuserTooltip"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          display: "flex",
                        }}
                      >
                        <a
                          style={{
                            color: "#563A96",
                            textDecoration: "underline",
                            fontSize: "14px",
                            fontWeight: "400",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          onClick={() => {
                            handleView(
                              props?.groupsessiondata?.recordings,
                              props?.groupsessiondata?.recordings,
                              props?.groupsessiondata?.cohortAdminId
                            );
                          }}
                        >
                          View Recording
                        </a>
                        <span
                          className="tooltiptext   tooltip-bottom"
                          style={{
                            left: "20px",
                            top: "30px",
                            width: "150px",
                            padding: "0px 0px 5px",
                          }}
                        >
                          Click to Play Recording
                        </span>
                      </p>
                      </div>
                    </>

                : ""
              }
              {props?.sessiondata?.sessionData?.recording != null && (
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: "14px",
                    lineHeight: "22px",
                    paddingLeft: "2rem",
                    display: "flex",
                  }}
                >
                  Recording Playback:{" "}
                  {props?.sessiondata?.sessionData?.recording == null ? (
                    "-"
                  ) : (
                    <>
                      <p
                        className="newuserTooltip"
                        style={{
                          marginLeft: "5px",
                          position: "relative",
                          display: "flex",
                        }}
                      >
                        <a
                          style={{
                            color: "#563A96",
                            textDecoration: "underline",
                            fontSize: "14px",
                            fontWeight: "400",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          onClick={() => {
                            handleView(
                              props?.sessiondata?.sessionData?.recording,
                              props?.sessiondata?.sessionData?.recordings,
                              props?.sessiondata?.sessionData?.cohortAdminId
                            );
                          }}
                        >
                          View Recording
                        </a>
                        <span
                          className="tooltiptext   tooltip-bottom"
                          style={{
                            left: "20px",
                            top: "30px",
                            width: "150px",
                            padding: "0px 0px 5px",
                          }}
                        >
                          Click to Play Recording
                        </span>
                      </p>
                    </>
                  )}
                </div>
              )}
            </div>
            <div className="session-detailsModal">
              <div
                className="col-md-12"
                style={{
                  // paddingLeft: "4.7%",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "black",
                  }}
                >
                  Session Goals:
                  {(props?.sessiondata?.sessionData?.sessionType ===
                    "cohortSession" ||
                    props?.allCalendarData) && (
                    <ul>
                      {props?.groupsessiondata?.sessionGoals?.map(
                        (item, index) => (
                          <li
                            key={index}
                            style={{
                              fontWeight: "normal",
                              fontSize: "14px",
                              lineHeight: "22px",
                            }}
                          >
                            {item}
                          </li>
                        )
                      )}
                    </ul>
                  )}
                  {(props?.sessiondata?.sessionData?.sessionType !=
                    "cohortSession" ||
                    !props?.allCalendarData) && (
                    <ul>
                      {props?.sessiondata?.sessionData?.sessionGoals?.map(
                        (item, index) => (
                          <li
                            key={index}
                            style={{
                              fontWeight: "normal",
                              fontSize: "14px",
                              lineHeight: "22px",
                            }}
                          >
                            {item}
                          </li>
                        )
                      )}
                    </ul>
                  )}
                </div>
                {(props?.sessiondata?.sessionData?.sessionType ===
                  "cohortSession" ||
                  props?.allCalendarData) && (
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      marginTop: "-10px",
                      color: "black",
                    }}
                  >
                    Description/Remark:
                    <p
                      style={{
                        fontWeight: "normal",
                        fontSize: "14px",
                        lineHeight: "22px",

                        paddingLeft: "2rem",
                      }}
                    >
                      {props?.groupsessiondata?.desiredOutcomes}
                    </p>
                  </div>
                )}
                {props?.sessiondata?.sessionData?.sessionType !=
                  "cohortSession" &&
                  !props?.allCalendarData && (
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      Description/Remark:
                      <p
                        style={{
                          fontWeight: "normal",
                          fontSize: "14px",
                          lineHeight: "22px",
                          paddingLeft: "2rem",
                          color: "black",
                        }}
                      >
                        {props?.sessiondata?.sessionData?.desiredOutcomes}
                      </p>
                    </div>
                  )}
              </div>
            </div>
            {/* {props?.sessiondata?.sessionData?.sessionStatus === "COMPLETED"
              ? `Session Completed`
              : props?.sessiondata?.sessionData?.sessionStatus == "SCHEDULED" &&
                new Date(
                  moment(props?.sessiondata?.sessionData?.sessionEnd).format(
                    "YYYY-MM-DDThh:mm:ssZ"
                  )
                ) < new Date()
              ? "Session Incomplete"
              : `Session Scheduled at ${
                  props?.sessiondata?.daySpawns
                    ? props?.sessiondata?.daySpawns[0]
                    : props?.sessiondata?.originDate
                } ${moment(
                  props?.sessiondata?.sessionData?.sessionTime,
                  "hh:mm"
                ).format("hh:mm a")}
            (${props?.sessiondata?.sessionData?.sessionDuration} hours)`}{" "} */}
          </Modal.Title>
          <Modal.Body>
            {/* <div className="session-detailsModal">
              <div
                className="col-md-12"
                style={{ paddingLeft: "4.7%", width: "90%" }}
              >
                <div style={{ fontWeight: "bold", fontSize: "14px" }}>
                  Session Goals:
                  {props?.sessiondata?.sessionData?.sessionType ===
                    "cohortSession" && (
                    <ul>
                      {props?.groupsessiondata?.sessionGoals?.map(
                        (item, index) => (
                          <li
                            key={index}
                            style={{
                              fontWeight: "normal",
                              fontSize: "14px",
                              lineHeight: "22px",
                            }}
                          >
                            {item}
                          </li>
                        )
                      )}
                    </ul>
                  )}
                  {props?.sessiondata?.sessionData?.sessionType !=
                    "cohortSession" && (
                    <ul>
                      {props?.sessiondata?.sessionData?.sessionGoals?.map(
                        (item, index) => (
                          <li
                            key={index}
                            style={{
                              fontWeight: "normal",
                              fontSize: "14px",
                              lineHeight: "22px",
                            }}
                          >
                            {item}
                          </li>
                        )
                      )}
                    </ul>
                  )}
                </div>
                {props?.sessiondata?.sessionData?.sessionType ===
                  "cohortSession" && (
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      marginTop: "-10px",
                    }}
                  >
                    Description/Remark:
                    <p
                      style={{
                        fontWeight: "normal",
                        fontSize: "14px",
                        lineHeight: "22px",

                        paddingLeft: "2rem",
                      }}
                    >
                      {props?.groupsessiondata?.desiredOutcomes}
                    </p>
                  </div>
                )}
                {props?.sessiondata?.sessionData?.sessionType !=
                  "cohortSession" && (
                  <div style={{ fontWeight: "bold", fontSize: "14px" }}>
                    Description/Remark:
                    <p
                      style={{
                        fontWeight: "normal",
                        fontSize: "14px",
                        lineHeight: "22px",
                        paddingLeft: "2rem",
                      }}
                    >
                      {props?.sessiondata?.sessionData?.desiredOutcomes}
                    </p>
                  </div>
                )}
              </div>
            </div> */}
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-around">
            {/* <div
              className="d-flex justify-between sessionFooterFix"
              style={{ left: "6.5px" }}
            >
              {props?.sessiondata?.sessionData?.sessionStatus == "COMPLETED" ? (
                <>
                  <div>
                    <Button
                      onClick={handleClose}
                      text="CLOSE"
                      className="modalButton51 doc-upload"
                      style={{ marginTop: "0px" }}
                    ></Button>
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <Button
                      onClick={handleg}
                      text="EDIT"
                      className="modalButton51 doc-upload"
                    ></Button>
                  </div>
                  <div>
                    <Button
                      onClick={handleDelete}
                      text="DELETE"
                      className="modalButton51 doc-uploadnext"
                    ></Button>
                  </div>
                </>
              )}
            </div> */}
            {props?.sessiondata?.sessionData?.sessionStatus == "COMPLETED" ||
            (props?.sessiondata?.sessionData?.sessionStatus == "SCHEDULED" &&
              new Date(
                moment(props?.sessiondata?.sessionData?.sessionEnd).format(
                  "YYYY-MM-DDThh:mm:ssZ"
                )
              ) < new Date()) ? (
              <>
                {/* <div>
                    <Button
                      onClick={handleClose}
                      text="CLOSE"
                      className="modalButton51 doc-upload"
                      style={{ marginTop: "0px" }}
                    ></Button>
                  </div> */}
                <div>
                  {loggedIn !== undefined &&
                  loggedIn !== null &&
                  props?.sessiondata?.sessionData?.addedBy === loggedIn?.id &&
                  props?.sessiondata?.sessionData?.sessionStatus ===
                    "SCHEDULED" &&
                  showEditSession ? (
                    <Button
                      onClick={handleEdit2}
                      text="EDIT"
                      className="modalButton51 doc-upload"
                    ></Button>
                  ) : (
                    ""
                  )}
                  {loggedIn !== undefined &&
                  loggedIn !== null &&
                  loggedIn?.id === props?.groupsessiondata?.cohortAdminId &&
                  props?.groupsessiondata?.sessionStatus === "SCHEDULED" &&
                  showEditCohort ? (
                    <Button
                      onClick={handleEdit}
                      text="EDIT"
                      className="modalButton51 doc-upload"
                    ></Button>
                  ) : (
                    ""
                  )}
                  {/* {
                        loggedIn?.id  === props?.groupsessiondata?.cohortAdminId  && props?.groupsessiondata?.sessionStatus === "SCHEDULED" && showEditCohort ? (
                          <Button
                          onClick={handleEdit}
                          text="EDIT"
                          className="modalButton51 doc-upload"
                        ></Button>
                        ):""
                      } */}

                  <Button
                    onClick={handleClose}
                    text="CLOSE"
                    className="modalButton51 doc-upload newBtnhere"
                    // style={{ right: "0rem", margin: "auto", width: "140px" }}
                  ></Button>
                  {props?.sessiondata?.sessionData?.sessionType !==
                    "mentorSession" &&
                  props?.groupsessiondata?.sessionStatus == "CLOSED" &&
                  props?.groupsessiondata?.isNotesSubmitted == false &&
                  loggedIn !== undefined &&
                  loggedIn?.role !== "Admin" &&
                  loggedIn !== null ? (
                    // !testFillNoteVisibility(props) &&
                    // testIncompleteStatus(props?.groupsessiondata)
                    // props?.groupsessiondata?.addedBy !== loggedIn?.id && !props?.groupsessiondata?.isFeedbackSubmitted?
                    <Button
                      onClick={() => {
                        if (
                          props?.groupsessiondata?.isSpeaker ||
                          props?.groupsessiondata?.addedBy == loggedIn?.id
                        ) {
                          handleMomPopup(
                            props?.sessiondata?.sessionData,
                            props
                          );
                        } else {
                          setMentorFeedbackModalOpen(true);
                          setCohortGroupSessionId(
                            props?.groupsessiondata?.cohortGroupSessionId
                          );
                        }
                      }}
                      text={
                        props?.groupsessiondata?.isSpeaker ||
                        props?.groupsessiondata?.addedBy == loggedIn?.id
                          ? "FILL NOTES"
                          :  "GIVE FEEDBACK"
                      }
                      className="modalButton51 doc-upload newBtnhere"
                      // style={{ right: "0rem", margin: "auto", width: "140px" }}
                    ></Button>
                  ) : // :""
                  props &&
                    props?.sessiondata?.sessionData?.sessionType ==
                      "mentorSession" &&
                    loggedIn?.role === "Mentor" &&
                    props?.sessiondata?.sessionData?.sessionStatus !==
                      "CANCELLED" &&
                    loggedIn !== undefined &&
                    loggedIn !== null &&
                    props?.sessiondata?.sessionData?.momMentorSubmitted ==
                      false && testIncompleteStatus(props?.sessiondata?.sessionData) ? (
                    //  !testFillNoteVisibility(props)
                    <Button
                      onClick={() =>
                        handleMomPopup(props?.sessiondata?.sessionData, props)
                      }
                      text="FILL NOTES"
                      className="modalButton51 doc-upload newBtnhere"
                      // style={{ right: "0rem", margin: "auto", width: "140px" }}
                    ></Button>
                  ) : props &&
                    props?.sessiondata?.sessionData?.sessionType ==
                      "mentorSession" &&
                    loggedIn?.role === "Startup" &&
                    loggedIn !== undefined &&
                    loggedIn !== null &&
                    props?.sessiondata?.sessionData?.sessionStatus !==
                      "CANCELLED" &&
                    props?.sessiondata?.sessionData?.momStartupSubmitted ==
                      false && testIncompleteStatus(props?.sessiondata?.sessionData) ? (
                    //  !testFillNoteVisibility(props)
                    <Button
                      onClick={() =>
                        handleMomPopup(props?.sessiondata?.sessionData, props)
                      }
                      text="FILL NOTES"
                      className="modalButton51 doc-upload newBtnhere"
                      // style={{ right: "0rem", margin: "auto", width: "140px" }}
                    ></Button>
                  ) : (
                    ""
                  )}
                </div>
              </>
            ) : (
              <>
                <div>
                  {/* <Button
                    onClick={handleEdit}
                    text="EDIT"
                    className="modalButton51 doc-upload"
                  ></Button>
                </div>
                <div>
                  <Button
                    onClick={handleDelete}
                    text="DELETE"
                    className="modalButton51 doc-uploadnext"
                  ></Button> */}
                  {/* <a
                    href={props?.sessiondata?.sessionData?.vcUrl}
                    target="_blank"
                    style={{ color: "#563A96", fontWeight: 600 }}
                  >
                    Click to Join MAARG Session
                  </a> */}

                  {loggedIn !== undefined &&
                  loggedIn !== null &&
                  loggedIn?.id === props?.groupsessiondata?.cohortAdminId &&
                  props?.groupsessiondata?.sessionStatus === "SCHEDULED" &&
                  showEditCohort ? (
                    <Button
                      onClick={handleEdit}
                      text="EDIT"
                      className="modalButton51 doc-upload"
                    ></Button>
                  ) : (
                    ""
                  )}

                  {loggedIn !== undefined &&
                  loggedIn !== null &&
                  props?.sessiondata?.sessionData?.addedBy === loggedIn?.id &&
                  props?.sessiondata?.sessionData?.sessionStatus ===
                    "SCHEDULED" &&
                  showEditSession ? (
                    <Button
                      onClick={handleEdit2}
                      text="EDIT"
                      className="modalButton51 doc-upload"
                    ></Button>
                  ) : (
                    ""
                  )}
                  <Button
                    onClick={handleClose}
                    text="CLOSE"
                    className="modalButton51 doc-upload newBtnhere"
                    // style={{ right: "0rem", margin: "auto", width: "140px" }}
                  ></Button>
                 
                 
                  {loggedIn !== undefined &&
                  loggedIn !== null &&
                  props?.sessiondata?.sessionData?.sessionType !==
                    "mentorSession" &&
                    loggedIn?.role !== "Admin" &&
                  props?.groupsessiondata?.sessionStatus == "CLOSED" &&
                  props?.groupsessiondata?.isNotesSubmitted == false && testIncompleteStatus(props?.sessiondata?.sessionData) ? (
                    // !testFillNoteVisibility(props) &&
                    // testIncompleteStatus(props?.groupsessiondata)
                    // props?.groupsessiondata?.addedBy !== loggedIn?.id && !props?.groupsessiondata?.isFeedbackSubmitted?
                    <Button
                      onClick={() => {
                        if (
                          props?.groupsessiondata?.isSpeaker ||
                          props?.groupsessiondata?.addedBy == loggedIn?.id
                        ) {
                          handleMomPopup(
                            props?.sessiondata?.sessionData,
                            props
                          );
                        } else {
                          setMentorFeedbackModalOpen(true);
                          setCohortGroupSessionId(
                            props?.groupsessiondata?.cohortGroupSessionId
                          );
                        }
                      }}
                      text={
                        props?.groupsessiondata?.isSpeaker ||
                        props?.groupsessiondata?.addedBy == loggedIn?.id
                          ? "FILL NOTES"
                          : "GIVE FEEDBACK"
                      }
                      className="modalButton51 doc-upload newBtnhere"
                      // style={{ right: "0rem", margin: "auto", width: "140px" }}
                    ></Button>
                  ) : // :""
                  props &&
                    loggedIn !== undefined &&
                    loggedIn !== null &&
                    props?.sessiondata?.sessionData?.sessionType ==
                      "mentorSession" &&
                    loggedIn?.role === "Mentor" &&
                    props?.sessiondata?.sessionData?.sessionStatus !==
                      "CANCELLED" &&
                      props?.sessiondata?.sessionData?.sessionStatus !==
                      "SCHEDULED" &&
                    props?.sessiondata?.sessionData?.momMentorSubmitted ==
                      false && testIncompleteStatus(props?.sessiondata?.sessionData) ? (
                    //  !testFillNoteVisibility(props)
                    <Button
                      onClick={() =>
                        handleMomPopup(props?.sessiondata?.sessionData, props)
                      }
                      text="FILL NOTES"
                      className="modalButton51 doc-upload newBtnhere"
                      // style={{ right: "0rem", margin: "auto", width: "140px" }}
                    >
                      {

                      }
                    </Button>
                  ) : props &&
                    props?.sessiondata?.sessionData?.sessionType ==
                      "mentorSession" &&
                    loggedIn?.role === "Startup" &&
                    props?.sessiondata?.sessionData?.sessionStatus ===
                      "CANCELLED" &&
                    props?.sessiondata?.sessionData?.momStartupSubmitted ==
                      false && testIncompleteStatus(props?.sessiondata?.sessionData) ? (
                    //  !testFillNoteVisibility(props)
                    <Button
                      onClick={() =>
                        handleMomPopup(props?.sessiondata?.sessionData, props)
                      }
                      text="FILL NOTES"
                      className="modalButton51 doc-upload newBtnhere"
                      // style={{ right: "0rem", margin: "auto", width: "140px" }}
                    ></Button>
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}

                  {
                   props?.groupsessiondata?.recordings !== undefined &&
                   props?.groupsessiondata?.recordings !== null &&
                   props?.groupsessiondata?.recordings !== "" &&
                   props?.groupsessiondata?.recordings?.length > 0  &&
                     <Button
                     onClick={() => {
                      handleView(
                        props?.groupsessiondata?.recordings,
                        props?.groupsessiondata?.recordings,
                        props?.groupsessiondata?.cohortAdminId
                      );
                    }}                    text="RECORDINGS"
                    className="modalButton51 docuploadNew"
                    // style={{ right: "0rem", margin: "auto", width: "140px" }}
                  ></Button>
                  }
                  {/* {
                   props?.sessiondata?.sessionData?.recordings !== undefined &&
                   props?.sessiondata?.sessionData?.recordings !== null &&
                   props?.sessiondata?.sessionData?.recordings !== "" &&
                   props?.sessiondata?.sessionData?.recordings?.length > 0  &&
                     <Button
                    onClick={handleClose}
                    text="RECORDINGS"
                    className="modalButton51 doc-upload newBtnhere"
                    // style={{ right: "0rem", margin: "auto", width: "140px" }}
                  ></Button>
                  } */}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, {
  deleteSessionData,
  cohortSessionNotesGiveFeedBack,
  detailsGroupSession,
  statusGroupSession,
  cohortSessionGiveFeedBack,
})(withRouter(SessionsModal2));
